module.exports = __webpack_public_path__ + "fca99e6418e10228412499f0a0081d77.png";